import { Injectable } from '@angular/core';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AssetTypeModel } from '../model/asset-type.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AssetTypeService {
  private readonly assetTypesURL = RestApiModel.PROXY_API_URL + '/assetTypes';
  private readonly createAssetTypeURL = `${
    RestApiModel.PROXY_API_URL
  }/assetType`;
  private readonly assetTypeURL = `${RestApiModel.PROXY_API_URL}/assetType/{1}`;

  constructor(private http: HttpClient) {
    // gold.
  }

  /**
   * GET - Obtain the list of asset types.
   * @returns {Observable<Array<AssetTypeModel>>}
   */
  getAssetTypes(): Observable<Array<AssetTypeModel>> {
    return this.http.get(`${this.assetTypesURL}`).pipe(
      map((res: any) => {
        return res.results ? res.results : [];
      }),
      catchError(error => Observable.of(error))
    );
  }

  /**
   * GET - get asset type by id
   */
  //   getAssetType(id: number): Observable<AssetTypeModel> {
  //     return this.http
  //       .get(this.assetTypeURL.replace('{1}', id.toString()))
  //       .map((res: any) => {
  //         return res.results ? res.results : null;
  //       })
  //       .catch(this.handleError);
  //   }

  /**
   * POST - Create a new asset type.
   * @param {AssetTypeModel} AssetTypeModel
   * @returns {Observable<any>}
   */
  createAssetType(assetTypeModel: AssetTypeModel): Observable<any> {
    return this.http.post(this.createAssetTypeURL, assetTypeModel as any).pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
  }

  /**
   * PUT - edit a asset type.
   * @param {AssetTypeModel} AssetTypeModel
   * @returns {Observable<any>}
   */
  updateAssetType(assetTypeModel: AssetTypeModel): Observable<any> {
    return this.http
      .put(
        this.assetTypeURL.replace('{1}', assetTypeModel.id.toString()),
        assetTypeModel as any
      )
      .pipe(
        map((res: any) => res),
        catchError(this.handleError)
      );
  }

  /**
   * DELETE - mark an asset type Inactive.
   * @param {AssetTypeModel} AssetTypeModel
   * @returns {Observable<any>}
   */
  deleteAssetType(assetTypeModel: AssetTypeModel): Observable<any> {
    return this.http
      .delete(
        this.assetTypeURL.replace('{1}', assetTypeModel.id.toString()),
        assetTypeModel as any
      )
      .pipe(
        map((res: any) => res),
        catchError(this.handleError)
      );
  }

  /**
   * Resolves the given error as JSON object
   */
  private handleError(error: any) {
    console.log(error);
    return error;
  }
}
